import { type ReactNode } from 'react';
import { observer } from 'mobx-react';
import Drawer from 'components/common/feedback/drawer';
import useStores from 'hooks/use-stores.hooks';
import { NAVBAR_WIDTH, NAVBAR_COLLAPSED_WIDTH } from 'constants/themes.constants';
import { useNavbarCollapse } from 'components/layout/navbar/navbar-collapse-context';

interface Props {
  bypass: boolean;
  children?: ReactNode;
}

const NavBarDrawer = ({ bypass, children }: Props) => {
  const { navbarStore } = useStores();
  const { isCollapsed } = useNavbarCollapse();
  const drawerWidth = isCollapsed ? NAVBAR_COLLAPSED_WIDTH : NAVBAR_WIDTH;

  return bypass ? (
    <>{children}</>
  ) : (
    <Drawer
      variant="flush"
      open={navbarStore.isOpen}
      placement="left"
      width={drawerWidth}
      onClose={() => navbarStore.setOpen(false)}
      closable={false}
      destroyOnClose={false}>
      {children}
    </Drawer>
  );
};

export default observer(NavBarDrawer);
